import { useState } from "react";

const BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:8080";

// Lee JSON si existe, si no lee texto (para evitar "Unexpected token <")
async function readResponseBody(response) {
  const contentType = response.headers.get("content-type") || "";

  // Intentar JSON solo si el server lo indica
  if (contentType.includes("application/json")) {
    try {
      return await response.json();
    } catch {
      // JSON malformado: cae a texto
    }
  }

  // Fallback a texto
  const text = await response.text().catch(() => "");
  return { message: text };
}

export default function useBackend() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const post = async (path, token, body) => {
    setLoading(true);
    setError(null);

    try {
      const response = await fetch(`${BASE_URL}${path}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        body: JSON.stringify(body ?? {}),
      });

      const payload = await readResponseBody(response);

      if (!response.ok) {
        const msg =
          payload?.userMessage ||
          payload?.message ||
          `Error ${response.status}`;

        const err = new Error(msg);
        err.status = response.status;
        err.payload = payload;
        throw err;
      }

      setData(payload);
      return payload;
    } catch (err) {
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return { data, loading, error, post };
}
